import React from 'react';
import Popper from '@mui/material/Popper';

const LargePopper = (props: any) => {
  const rect = props.anchorEl.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const topSpace = rect.top;
  const bottomSpace = windowHeight - rect.bottom;

  const placement = bottomSpace > topSpace ? 'bottom-start' : 'top-start';
  const height = bottomSpace > topSpace ? bottomSpace - 20 : topSpace - 20;

  return (
    <div>
      <Popper
        {...props}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: '0 4px 10px -1px rgb(17 20 24 / 20%)',
            border: '1px solid #9c1111',
            borderTop: '0px',
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '0px',
          },
          '& .MuiAutocomplete-listbox': {
            maxHeight: `${height}px`,
            '& .MuiAutocomplete-option': {
              paddingY: '2px',
              fontSize: '11px',
            },
          },
        }}
        style={{
          width: 'fit-content',
        }}
        placement={placement}
      />
    </div>
  );
};

export default LargePopper;
